import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4b3a8e6c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4b3a8e6c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3a8e6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b3a8e6c')) {
      api.createRecord('4b3a8e6c', component.options)
    } else {
      api.reload('4b3a8e6c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4b3a8e6c&scoped=true", function () {
      api.rerender('4b3a8e6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/education/choosecurriculum/index.vue"
export default component.exports